
import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { ATTITUDE_ICON_LIST } from '../../../constants';
import { Tooltip } from '@trendmicro/react-tooltip';
import { numberWithCommas } from '../../../util/CommonUtils';

class SalesCatalystAttitudeComparisionDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {

    };
  }

  getImageIcon = imageKey => {
    let selectedIcon;
    const imageComponent = _.find(ATTITUDE_ICON_LIST, { id: imageKey });
    if (imageComponent !== undefined) {
      selectedIcon = imageComponent.selectedIcon;
    }
    return selectedIcon;
  };

  getToolTip = data => {
    if (data) {
      return (
        <span style={{ whiteSpace: 'nowrap', border: 'black', color: 'black', fontSize: '11px' }}>
          <span className=" sc-attitude-choice-level">{data.level}</span><br />
          INDEX:&nbsp;<strong>{numberWithCommas(Math.round(data.value.index))}</strong><br />
          REACH:&nbsp;<strong>{data.value.pct}</strong><br />
          SAMPLE:&nbsp;<strong> {numberWithCommas(Math.round(data.value.sample))}</strong><br />
          WEIGHTED:&nbsp;<strong> {numberWithCommas(Math.round(data.value.weighted))}</strong><br />
        </span>
      );
    }
  }

  render() {
    return (
      <div className="row fullWidth table-container sc-attitude-col-height">
        <div className="attitude-comparision-float">
          <div className="sc-attitude-float">
            <div
              className="sc-attitude-comparision-image-border attitude-float"
            >
              {this.getImageIcon(
                  _.camelCase(this.props.scAttitudeObj.icon.replace('.png', '')),
                ) === undefined && <div className="imageblock" />}
              {this.getImageIcon(
                  _.camelCase(this.props.scAttitudeObj.icon.replace('.png', '')),
                ) !== undefined && (
                  <Tooltip
                    placement="left"
                    tooltipClassName="sc-reactTooltip-attitude"
                    leaveDelay={-2}
                    content={() => {
                      return this.getToolTip(this.props.scAttitudeObj);
                    }}
                  >
                   <span>
                  <img
                    className="profile-top5-img"
                    src={this.getImageIcon(
                      _.camelCase(this.props.scAttitudeObj.icon.replace('.png', '')),
                    )}
                    alt=""
                    key=""
                  />
                  </span>
                  </Tooltip>
                )}
              <div className="attitude-comparision-icon-labels">
                {' '}
              </div>
            </div>
          </div>
          <div className="sc-attitude-label-height">
            <div
              className="div-overflow"
              id="attitudeComparisionLabelheight"
            >

              <div
                className="sc-attitude-comparision-labels"
                id="pdfAttituteLabels"
              >
                <div className=" sc-attitude-choice-level">
                <Tooltip
                  placement="left"
                  tooltipClassName="sc-reactTooltip-attitude"
                  leaveDelay={-2}
                  content={() => {
                    return this.getToolTip(this.props.scAttitudeObj);
                  }}
                >
                <span>
                {this.props.scAttitudeObj.level !== undefined ?
                  this.props.scAttitudeObj.level : 'N/A'}
                </span>
                </Tooltip>
                </div>

                <div className="sc-block-with-text">
                <Tooltip
                  placement="left"
                  tooltipClassName="sc-reactTooltip-attitude"
                  leaveDelay={-2}
                  content={() => {
                    return this.getToolTip(this.props.scAttitudeObj);
                  }}
                >
                 <span>{this.props.scAttitudeObj.label !== undefined ? this.props.scAttitudeObj.label : 'NA' }</span>
                 </Tooltip>
                 </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
  };
}

export default connect(
  mapStateToProps,
  null,
)(SalesCatalystAttitudeComparisionDetail);

